"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.split = void 0;
var _ApolloLink = require("apollo-stack-hubspot/@apollo/client/link/core/ApolloLink");
var split = exports.split = _ApolloLink.ApolloLink.split;